import React from 'react';
import Link from 'gatsby-link';

import './footer.scss';
import logo from '../../assets/img/jp-electric-footer-logo.png';

const Footer = () => (
  <div className="footer tk-aktiv-grotesk">
    <div className="container page-padding">
      <div className="logo-container">
        <img className="logo" src={logo} alt="JP Electric" />
      </div>
      <div className="contact-info">
        <div className="address">
          1910 Enterprise St.<br />
          Marquette, MI 49855
        </div>
        <br />
        <div className="phone">
          <a href="tel:9062289487">
            (906) 228-9478
          </a>
        </div>
      </div>
      <div className="copyright">
        © JP Electric 2018<br />
        Design by <Link to="https://www.elegantseagulls.com">Elegant Seagulls</Link>
      </div>
    </div>
  </div>
)

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/footer.js